<template>
  <span class="flex flex-col lg:gap-2">
    <Typography class="font-light opacity-70 !text-xs lg:!text-lg min-w-[11ch] text-nowrap ">Time remaining</Typography>
    <Typography class="text-end text-primary !text-xs lg:!text-lg font-semibold">{{ formattedTime }}</Typography>
  </span>
</template>
  
<script>
import Typography from "./common/Typography.vue"

import { DateTime } from "luxon";

export default {
  components: {
    Typography,
  },
  props: {
    targetDate: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      timeLeft: null,
    };
  },
  computed: {
    formattedTime() {
      if (!this.timeLeft) return "0d 0h 0min";
      const { days, hours, minutes, seconds } = this.timeLeft;
      return `${days}d ${hours}h ${minutes}min`;
    },
  },
  methods: {
    calculateTimeLeft() {
      /*
      const now = DateTime.local();
      const target = DateTime.fromISO(this.targetDate);
      const diff = target.diff(now, ["days", "hours", "minutes", "seconds"]);
      */
     // targetDate is UTC
      const now = DateTime.utc();
      const target = DateTime.fromISO(this.targetDate, { zone: "utc" });
      const diff = target.diff(now, ["days", "hours", "minutes", "seconds"]);
      if (diff <= 0) {
        return null;
      }

      return {
        days: Math.floor(diff.days),
        hours: Math.floor(diff.hours),
        minutes: Math.floor(diff.minutes),
        seconds: Math.floor(diff.seconds),
      };
    },
    updateTimeLeft() {
      this.timeLeft = this.calculateTimeLeft();
    },
  },
  mounted() {
    this.updateTimeLeft();
    this.interval = setInterval(this.updateTimeLeft, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>
  
  <style scoped>
</style>
  